import { render, staticRenderFns } from "./section-block-top.vue?vue&type=template&id=55a239a9&"
import script from "./section-block-top.vue?vue&type=script&lang=js&"
export * from "./section-block-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports